import type { RouteRecordRaw } from 'vue-router'

import { organizationDetailLayoutMeta } from './shared'

const routeInvestorDetail: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/views/relations/OrganizationDetailView.vue')
  },
  name: 'investor-detail',
  path: '',
}

const routeInvestorFileOverview: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/viewsExternal/submenus/file/SubmenuFiles.vue')
  },
  name: 'investor-file-overview',
  path: 'file-overview',
}

const routeInvestorInformation: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/viewsExternal/submenus/investor/SubmenuInformation.vue')
  },
  name: 'investor-information',
  path: 'investor-information',
}

const routeInvestorRoot: RouteRecordRaw = {
  children: [routeInvestorDetail, routeInvestorFileOverview, routeInvestorInformation],
  component: async () => {
    return await import('@/components/relationships/organizations/OrganizationDetailBase.vue')
  },
  meta: organizationDetailLayoutMeta,
  path: 'investors/:id',
}

export {
  routeInvestorDetail,
  routeInvestorFileOverview,
  routeInvestorInformation,
  routeInvestorRoot,
}
